import { useContext, useState } from 'react';
import { dealersContext } from '../DealersContext';
import { MenuItem, Grid, TextField, Button } from '@material-ui/core';
import { applicationContext, appUserContext } from 'helpers/services';
import { SearchOutlined as SearchIcon } from '@material-ui/icons';
import { Autocomplete } from '@material-ui/lab';


let Filters = () => {
    let service = useContext(dealersContext);
    let { currentUser } = useContext(appUserContext);
    let appService = useContext(applicationContext);


    let [searchCountry, setSearchCountry] = useState('');
    let [searchBrand, setSearchBrand] = useState('');
    let [searchProgram, setSearchProgram] = useState('');


    return (
        <form onSubmit={(e) => e.preventDefault()}>
            <Grid container spacing={2}>
                <Grid item xs>
                    <TextField
                        label='Name'
                        variant="outlined"
                        size="small"
                        fullWidth
                        value={service.search.name}
                        onChange={(e) => service.updateSearch({ ...service.search, name: e.target.value })}
                    />
                </Grid>
                {currentUser?.userType !== "Distributor" &&
                    <Grid item xs>
                        <TextField
                            label='M3 number'
                            variant="outlined"
                            size="small"
                            fullWidth
                            value={service.search.m3Number}
                            onChange={(e) => service.updateSearch({ ...service.search, m3Number: e.target.value })}
                        />
                    </Grid>
                }
                <Grid item xs>
                    <Autocomplete
                        size="small"
                        inputValue={searchProgram}
                        value={service.search.program}
                        onInputChange={(event, newInputValue) => setSearchProgram(newInputValue)}
                        getOptionLabel={(option) => appService.referenceData.programs.getValueByKey(option)}
                        options={appService.referenceData.programs.map(x => x.key)}
                        onChange={(e, value) => service.updateSearch({ ...service.search, program: value || '' })}
                        renderInput={(params) =>
                            <TextField
                                {...params}
                                fullWidth
                                label="Program"
                                variant="outlined"
                            />
                        }
                    />
                </Grid>
                <Grid item xs>
                    <Autocomplete
                        size="small"
                        inputValue={searchBrand}
                        value={service.search.brand}
                        onInputChange={(event, newInputValue) => setSearchBrand(newInputValue)}
                        getOptionLabel={(option) => appService.referenceData.brands.getValueByKey(option)}
                        options={appService.referenceData.brands.map(x => x.key)}
                        onChange={(e, value) => service.updateSearch({ ...service.search, brand: value || '' })}
                        renderInput={(params) =>
                            <TextField
                                {...params}
                                fullWidth
                                label="Brand"
                                variant="outlined"
                            />
                        }
                    />
                </Grid>
                <Grid item xs>
                    <Autocomplete
                        size="small"
                        inputValue={searchCountry}
                        value={service.search.countryCode}
                        onInputChange={(event, newInputValue) => setSearchCountry(newInputValue)}
                        getOptionLabel={(option) => appService.referenceData.countries.getValueByKey(option)}
                        options={appService.referenceData.countries.map(x => x.key)}
                        onChange={(e, value) => service.updateSearch({ ...service.search, countryCode: value || '' })}
                        renderInput={(params) =>
                            <TextField
                                {...params}
                                fullWidth
                                label="Country"
                                variant="outlined"
                            />
                        }
                    />
                </Grid>
                {currentUser?.userType !== "Distributor" &&
                    <Grid item xs>
                        <TextField
                            label='Source'
                            variant="outlined"
                            size="small"
                            fullWidth
                            select
                            value={service.search.source}
                            onChange={(e) => service.updateSearch({ ...service.search, source: e.target.value })}
                        >
                            <MenuItem value=''>Any</MenuItem>
                            <MenuItem value='Distributor'>Distributor</MenuItem>
                            <MenuItem value='M3'>M3</MenuItem>
                        </TextField>
                    </Grid>
                }
                <Grid item xs>
                    <TextField
                        label='Show only'
                        variant="outlined"
                        size="small"
                        fullWidth
                        select
                        value={service.search.isActive}
                        onChange={(e) => service.updateSearch({ ...service.search, isActive: e.target.value })}
                    >
                        <MenuItem value='true'>Active dealers</MenuItem>
                        <MenuItem value='false'>Not active dealers</MenuItem>
                    </TextField>
                </Grid>

                <Grid item>
                    <Button type="submit" variant="contained" onClick={service.doSearch}>
                        <SearchIcon />
                    </Button>
                </Grid>
            </Grid>
        </form>
    )
}

export default Filters;